module.exports = __webpack_public_path__ + "img/HC3P_RoundPreview.12d86817.png";